import { render, staticRenderFns } from "./RecursionMenu.vue?vue&type=template&id=6582bc7b&"
import script from "./RecursionMenu.vue?vue&type=script&lang=js&"
export * from "./RecursionMenu.vue?vue&type=script&lang=js&"
import style0 from "./RecursionMenu.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports